// Threads関係のAPIエンドポイント

const endpoints = {
  GET_THREADS: "/chat-threads",
};

export default endpoints;
